import React from 'react';
import html2pdf from 'html2pdf.js';
import { useTranslation } from 'react-i18next'; // ✅ Ավելացված է

const InvoiceModal = ({ isOpen, onClose, orderData }) => {
    const { t } = useTranslation(); // ✅ Ավելացված է

    if (!isOpen || !orderData) return null;

    const downloadPDF = () => {
        const element = document.getElementById('invoice-to-download');
        const opt = {
            margin: 10,
            filename: `Invoice_Order_${orderData.id}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };
        html2pdf().from(element).set(opt).save();
    };

    return (
        <div style={overlayStyle}>
            <div style={modalStyle}>
                <div id="invoice-to-download" style={invoiceContainerStyle}>
                    {/* Header */}
                    <div style={headerStyle}>
                        <div>
                            <h1 style={{ color: '#4318FF', margin: 0 }}>LIBER SERVICE</h1>
                            <p>{t('inv_prof_service')}</p>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <h2 style={{ margin: 0 }}>{t('inv_title')}</h2>
                            <p>{t('inv_number')}: #INV-{orderData.id}</p>
                            <p>{t('inv_date')}: {new Date().toLocaleDateString()}</p>
                        </div>
                    </div>

                    {/* Client Info */}
                    <div style={infoSectionStyle}>
                        <div>
                            <strong>{t('inv_from')}:</strong>
                            <p>{t('inv_company_name')}<br/>{t('inv_company_addr')}</p>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <strong>{t('inv_customer')}:</strong>
                            <p>{orderData.userName || t('inv_dear_customer')}<br/>{orderData.address}</p>
                        </div>
                    </div>

                    {/* Table */}
                    <table style={tableStyle}>
                        <thead>
                            <tr style={{ background: '#f8f9ff' }}>
                                <th style={thStyle}>{t('inv_th_service')}</th>
                                <th style={thStyle}>{t('inv_th_qty')}</th>
                                <th style={{ ...thStyle, textAlign: 'right' }}>{t('inv_th_price')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={tdStyle}>{orderData.service}</td>
                                <td style={tdStyle}>1</td>
                                <td style={{ ...tdStyle, textAlign: 'right' }}>{orderData.totalPrice || orderData.newPrice} ֏</td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Total */}
                    <div style={totalStyle}>
                        <h3>{t('inv_total')}: {orderData.totalPrice || orderData.newPrice} ֏</h3>
                    </div>
                </div>

                <div style={actionsStyle}>
                    <button onClick={downloadPDF} style={btnDownloadStyle}>⬇ {t('inv_btn_download')}</button>
                    <button onClick={onClose} style={btnCloseStyle}>{t('inv_btn_close')}</button>
                </div>
            </div>
        </div>
    );
};

// ... (Styles remain the same)
const overlayStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10000 };
const modalStyle = { background: 'white', padding: '20px', borderRadius: '12px', maxWidth: '700px', width: '95%' };
const invoiceContainerStyle = { padding: '40px', background: 'white', color: '#333' };
const headerStyle = { display: 'flex', justifyContent: 'space-between', borderBottom: '2px solid #4318FF', paddingBottom: '20px', marginBottom: '30px' };
const infoSectionStyle = { display: 'flex', justifyContent: 'space-between', marginBottom: '40px' };
const tableStyle = { width: '100%', borderCollapse: 'collapse' };
const thStyle = { padding: '12px', textAlign: 'left', borderBottom: '2px solid #eee' };
const tdStyle = { padding: '12px', borderBottom: '1px solid #eee' };
const totalStyle = { textAlign: 'right', marginTop: '30px', borderTop: '2px solid #eee', paddingTop: '10px' };
const actionsStyle = { display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px' };
const btnDownloadStyle = { background: '#28a745', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' };
const btnCloseStyle = { background: '#666', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer' };

export default InvoiceModal;